export type NavItem = {
  title: string;
  icon: string;
  to?: string;
  href?: string;
  /** Paths that should highlight this item (prefix match). Defaults to [to]. */
  matchPaths?: string[];
};

export type NavGroup = {
  label: string;
  items: NavItem[];
};

export const MENU_GROUPS: NavGroup[] = [
  {
    label: "Principal",
    items: [
      { title: "Dashboard", to: "/", icon: "mdi-view-dashboard", matchPaths: ["/"] },
    ],
  },
  {
    label: "Operação",
    items: [
      {
        title: "Vendas",
        to: "/sales",
        icon: "mdi-cart",
        matchPaths: ["/sales", "/pdv"],
      },
      {
        title: "Produtos",
        to: "/produtos",
        icon: "mdi-package-variant",
        matchPaths: ["/produtos", "/pdv/dashboard", "/pdv/products", "/estoque"],
      },
      { title: "Financeiro", to: "/financeiro", icon: "mdi-cash-multiple" },
    ],
  },
  {
    label: "Relacionamento",
    items: [
      {
        title: "Clientes",
        to: "/clients",
        icon: "mdi-account-group",
        matchPaths: ["/clients", "/client"],
      },
      { title: "Indicações", to: "/indications", icon: "mdi-account-plus" },
    ],
  },
  {
    label: "Conta",
    items: [
      { title: "Meus dados", to: "/my-data", icon: "mdi-account" },
      { title: "Configurações", to: "/settings", icon: "mdi-cog" },
      {
        title: "Tutoriais",
        href: "https://site.brpoints.com.br/tutoriais/?c=parceiro",
        icon: "mdi-school",
      },
    ],
  },
];

export const ROUTE_TITLES: Record<string, string> = {
  home: "Dashboard",
  sales: "Vendas",
  produtos: "Produtos",
  produtoNew: "Novo Produto",
  produtoEdit: "Editar Produto",
  financeiro: "Financeiro",
  pdv: "Nova Venda",
  pdvDashboard: "Dashboard PDV",
  clients: "Clientes",
  clientsImport: "Importar clientes",
  clientForm: "Cadastro de Cliente",
  clientDetail: "Cadastro de Cliente",
  saleNew: "Nova Venda",
  saleOnlineNew: "Venda Online",
  onboarding: "Onboarding",
  registrateContinue: "Concluir cadastro",
  onboardingChecklist: "Atualização de Cadastro",
  login: "Login",
  forgotPassword: "Recuperar Senha",
  myData: "Meus Dados",
  settings: "Configurações",
  indications: "Indicações",
  accountCancellationRequest: "Cancelar Conta",
  accountCancellationConfirmation: "Confirmação de Cancelamento",
};

export const ROUTE_BREADCRUMBS: Record<string, { label: string; to: string }> = {
  produtoNew: { label: "Produtos", to: "/produtos" },
  produtoEdit: { label: "Produtos", to: "/produtos" },
  clientsImport: { label: "Clientes", to: "/clients" },
  clientForm: { label: "Clientes", to: "/clients" },
  clientDetail: { label: "Clientes", to: "/clients" },
  pdv: { label: "Vendas", to: "/sales" },
  pdvDashboard: { label: "Produtos", to: "/produtos" },
  onboardingChecklist: { label: "Dashboard", to: "/" },
};

export const PUBLIC_ROUTE_NAMES = new Set([
  "login",
  "forgotPassword",
  "onboarding",
  "registrateContinue",
  "accountCancellationRequest",
  "accountCancellationConfirmation",
]);

export function isNavItemActive(path: string, item: NavItem): boolean {
  if (item.href || !item.to) return false;

  const candidates = item.matchPaths || [item.to];

  return candidates.some((candidate) => {
    if (candidate === "/") return path === "/";
    return path === candidate || path.startsWith(`${candidate}/`);
  });
}

export function getRouteTitle(routeName: string | null | undefined): string {
  if (!routeName) return "BRPoints";
  return ROUTE_TITLES[routeName] || "BRPoints";
}

export function getRouteBreadcrumb(routeName: string | null | undefined) {
  if (!routeName) return null;
  return ROUTE_BREADCRUMBS[routeName] || null;
}
